import { consume } from '@lit/context';
import { localized, t } from '@weavedev/lit-i18next';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { ConfigurationPrintOptionDto2 } from '@/api-sdk';
import { global, GlobalComponentType } from '@/context';
import { BREAKPOINT_SMALL_PX } from '@/settings';
import { baseStyles } from '@/styles';

import './retail/fg-configuration-print-option';
import './wholesale/fg-configuration-print-option';

@customElement('fg-configuration-print-option-list')
@localized()
export class FgConfigurationPrintOptionList extends LitElement {
  @property({ type: Array })
  printOptions: ConfigurationPrintOptionDto2[] = [];

  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  render() {
    if (!this.printOptions.length) {
      return null;
    }

    const { layout } = this.globalContext;

    return html`
      <h3>${t('headers.printoptions')}</h3>

      <div class="options-list">
        ${layout === 'retail'
          ? this.printOptions.map(
              printOption => html`
                <fg-configuration-print-option
                  part=${layout}
                  .printOption=${printOption}
                ></fg-configuration-print-option>
              `,
            )
          : this.printOptions.map(
              printOption => html`
                <fg-configuration-print-option-small
                  part=${layout}
                  .printOption=${printOption}
                ></fg-configuration-print-option-small>
              `,
            )}
      </div>
    `;
  }

  static styles = [
    baseStyles,
    css`
      :host {
        display: block;
        margin-top: 15px;
      }

      h3 {
        font-size: 1rem;
      }

      .options-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 10px;
      }

      :host([part='wholesale']) .options-list {
        gap: 3px;
      }

      @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
        h3 {
          font-size: 1.125rem;
        }
      }
    `,
  ];
}
